import React from "react";

const ShowOnPageSection = ({ tool, totalPages, handleChange, errorState, inline = false }) => inline ? (
  <>
    <label className="pv-pos-field">
      <span>Page</span>
      <input
        type="number"
        name="page"
        min={1}
        value={tool?.page ?? ''}
        onFocus={(e) => e.target.select()}
        onChange={handleChange}
      />
      <span className="pv-pos-of">/ {totalPages ?? 1}</span>
    </label>
    {((tool?.page == tool?.value?.page_link) || (tool?.page == tool?.jump_to_page)) && errorState?.pageErr && (
      <p className="text-danger pv-pos-error mb-0">{errorState?.pageErr}</p>
    )}
  </>
) : (
  <div className="show-on-page-section">
    <div className="show-on d-flex align-items-center justify-content-between">
      <p className="img-lab-clr mb-0 me-2">SHOW ON PAGE:</p>
      <div className="d-flex align-items-center">
        <input
          type="number"
          name="page"
          min={1}
          value={tool?.page}
          onFocus={(e) => e.target.select()}
          onChange={handleChange}
          style={{ height: '38px' }}
        />
        <span className="ms-2">/ {totalPages ?? 1}</span>
      </div>
    </div>
    {((tool?.page == tool?.value?.page_link) || (tool?.page == tool?.jump_to_page)) && (
      <p className="text-danger mt-2 mb-0">{errorState?.pageErr}</p>
    )}
  </div>
);
export default ShowOnPageSection;
